<template>
  <div class="content-wrapper">
    <SendGiftMenu
      :header="bundleDetails.attributes ? bundleDetails.attributes.name : ''"
    />
    <div class="arrow-link">
      <router-link :to="{ name: 'GiftList' }">
        <span class="inter">Back</span>
      </router-link>
    </div>

    <Loading
      v-if="!loadStatus && !bundleNotFound && !localBundleItems.length"
      text="Loading gift set..."
      style="margin-left: 0px"
    />
    <div class="bundle-detail-wrapper" v-if="bundleNotFound">
      <h1 id="bundle-not-found">Bundle not found</h1>
    </div>
    <!-- {{ localBundleItems.length }} -->
    <div
      class="bundle-detail-wrapper"
      v-if="loadStatus && !bundleNotFound && localBundleItems.length"
    >
      <div class="product-details">
        <h2 class="inter" v-show="showPrices">{{ retailPrice }}</h2>
        <p class="inter">{{ inventoryDescription() }}</p>
      </div>

      <!-- {{ localBundleItems }} -->
      <div class="gallery-container">
        <p class="gallery-description inter">
          Gift Set contains the following items
        </p>
        <!-- bundle item options selection -->
        <div class="bundle-gallery">
          <div
            class="bundle-holder"
            v-for="(product, index) in localBundleItems"
            :key="product.bundleId * index"
          >
            <!-- Product Image Here -->
            <div class="portrait">
              <img
                :src="photoURL(product)"
                @error="handleBrokenImage($event)"
              />
            </div>

            <div class="portrait-info">
              <p class="inter">{{ product.productName }}</p>

              <!-- Quantity here -->
              <div class="quantity">
                <span>Quantity </span>
                <span class="multiply"> x</span>
                <span class="count"> {{ product.bundleQty }}</span>
              </div>

              <!-- section for product type -->
              <template v-if="product.typesToDisplay.length">
                <div class="variant-details">
                  <p>Type</p>
                  <v-select
                    class="custom gift-select"
                    :options="
                      getTypeOptions(
                        product.typesToDisplay,
                        product.bundleId,
                        product.itemIndex
                      )
                    "
                    :placeholder="'Please select your type'"
                    :clearable="false"
                    :searchable="false"
                    :value="product.selectedType"
                    @input="setVariantType"
                  >
                    <template #open-indicator="{ attributes }">
                      <span v-bind="attributes"> <Dropdown /> </span>
                    </template>
                  </v-select>
                </div>
              </template>

              <!-- section for product color -->
              <template v-if="product.colorsToDisplay.length">
                <div class="variant-details color">
                  <p>Color</p>

                  <div class="variant-colors">
                    <div
                      v-for="variantColor in product.colorsToDisplay"
                      :key="variantColor.id"
                      class="outside-box"
                      :class="[
                        {
                          active: variantColor.color === product.selectedColor
                        },
                        {
                          'disabled-color': product.colorsToDisplay.length
                            ? variantColor.disabled
                            : ''
                        }
                      ]"
                      @click="
                        setVariantColor(product.itemIndex, variantColor.color)
                      "
                    >
                      <div
                        class="color-box"
                        :style="{
                          backgroundColor: variantColor.hexCode
                            ? variantColor.hexCode
                            : 'lightgray'
                        }"
                      >
                        {{ variantColor.hexCode ? '' : '?' }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- section for product sizes -->
              <template v-if="product.sizesToDisplay.length">
                <!-- <p class="type-header">Size</p> -->
                <div class="variant-details">
                  <p>Size</p>
                  <v-select
                    class="custom gift-select"
                    :options="
                      getSizeOptions(
                        product.sizesToDisplay,
                        product.bundleId,
                        product.itemIndex
                      )
                    "
                    :selectable="isSelectable"
                    :placeholder="'Please select your size'"
                    :clearable="false"
                    :searchable="false"
                    :value="product.selectedSize"
                    @input="setVariantSize"
                  >
                    <template #open-indicator="{ attributes }">
                      <span v-bind="attributes"> <Dropdown /> </span>
                    </template>
                  </v-select>
                </div>
                <!-- <ul class="variant-sizes">
                  <li
                    v-for="sizeVariant in product.sizesToDisplay"
                    :key="sizeVariant.size"
                    :class="[
                      {
                        'selected-size':
                          sizeVariant.size === product.selectedVariant.size
                      },
                      {
                        'disabled-size': product.sizesToDisplay.length
                          ? sizeVariant.disabled
                          : ''
                      }
                    ]"
                    @click="setVariantSize(product.itemIndex, sizeVariant.size)"
                  >
                    {{ sizeVariant.size }}
                  </li>
                </ul> -->
              </template>
            </div>
          </div>
        </div>

        <div class="flex justify-center">
          <button
            class="button-gemnote full-width button-gemnote--small"
            :class="{ 'button-gemnote--disabled': lowestOnInvetory <= 0 }"
            :disabled="lowestOnInvetory <= 0"
            @click="addToShoppingBag"
          >
            <span>Add to cart</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  progressStatus,
  layouts,
  defaultNotFoundImage,
  scrollPageToTop,
  handleBrokenImage
} from '../../helpers'
import Loading from '@/components/Loading'
import Util from '../../mixins/Util'
import SendGiftMenu from '@/components/SendGiftMenu'
import Dropdown from '../Universal/Dropdown.vue'

export default {
  name: 'BundleDetail',
  mixins: [Util],
  props: ['id'],

  components: {
    Loading,
    SendGiftMenu,
    Dropdown
  },

  data() {
    return {
      localBundleItems: [],
      retailPrice: 0,
      lowestOnInvetory: 0,
      handleBrokenImage: handleBrokenImage
    }
  },

  computed: {
    loadStatus() {
      return progressStatus(this.loadBundleDetails)
    },
    productName() {
      return (
        this.bundleDetails &&
        this.bundleDetails.attributes &&
        this.bundleDetails.attributes.name
      )
    },
    showPrices() {
      return this.$store.getters['team/showPrices']
    },
    ...mapState({
      loadBundleDetails: state => state.product.loadBundleDetails,
      bundleDetails: state => state.product.bundleDetails,
      bundleNotFound: state => state.product.bundleNotFound,
      bundleItems: state => state.product.bundleItems,
      shoppingBagProducts: state => state.order.shoppingBagProducts
    })
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.dispatch('product/getBundleDetails', this.$route.params.id)
    scrollPageToTop()
  },

  methods: {
    photoURL(product) {
      return product.selectedVariant.imageURL
        ? product.selectedVariant.imageURL
        : product.productVariants.length &&
          product.productVariants[0].representative_images &&
          product.productVariants[0].representative_images.length
        ? product.productVariants[0].representative_images[0].url
        : defaultNotFoundImage
    },
    setVariantType(variantType) {
      let { itemIndex } = variantType
      variantType = variantType.label
      let bundleIndex = this.localBundleItems.findIndex(
        bundle => bundle.itemIndex === itemIndex
      )

      this.localBundleItems[bundleIndex].selectedType = variantType
      this.localBundleItems[bundleIndex].selectedColor = null
      this.localBundleItems[bundleIndex].selectedSize = null
      this.localBundleItems[bundleIndex].selectedVariant = {
        id: null,
        name: '',
        displayName: '',
        type: null,
        color: null,
        size: null,
        price: null,
        imageURL: null,
        inventoriesCount: 0
      }

      // check available colors by type
      let { colorSizeDictionary } = this.localBundleItems[bundleIndex]
      let { colorsToDisplay } = this.localBundleItems[bundleIndex]
      let { sizesToDisplay } = this.localBundleItems[bundleIndex]

      // if there's colors to display we filter colors available by type
      if (colorsToDisplay.length) {
        let availableColorsByType = colorSizeDictionary.filter(
          colorSize => colorSize.type === variantType
        )

        for (let index = 0; index < colorsToDisplay.length; index++) {
          let foundColor = availableColorsByType.find(
            availableColor =>
              availableColor.color === colorsToDisplay[index].color
          )

          if (foundColor) {
            this.localBundleItems[bundleIndex].colorsToDisplay[
              index
            ].disabled = false
          } else {
            this.localBundleItems[bundleIndex].colorsToDisplay[
              index
            ].disabled = true
          }
        }

        // disable sizes
        this.localBundleItems[bundleIndex].sizesToDisplay.forEach(
          variantSize => {
            variantSize.disabled = true
          }
        )
      } else if (sizesToDisplay.length) {
        // Otherwise we filter sizes availables by type
        let availableSizesByType = colorSizeDictionary.filter(
          colorSize => colorSize.type === variantType
        )

        // if there's sizes to display
        for (let index = 0; index < sizesToDisplay.length; index++) {
          let foundSize = availableSizesByType.find(
            availableSize => availableSize.size === sizesToDisplay[index].size
          )

          if (foundSize) {
            this.localBundleItems[bundleIndex].sizesToDisplay[
              index
            ].disabled = false
          } else {
            this.localBundleItems[bundleIndex].sizesToDisplay[
              index
            ].disabled = true
          }
        }
      } else {
        this.setSelectedVariant(bundleIndex)
        this.updateBundlePrice()
      }
    },
    setVariantColor(itemIndex, variantColor) {
      let bundleIndex = this.localBundleItems.findIndex(
        bundle => bundle.itemIndex === itemIndex
      )

      this.localBundleItems[bundleIndex].selectedColor = variantColor
      this.localBundleItems[bundleIndex].selectedSize = null
      this.localBundleItems[bundleIndex].selectedVariant = {
        id: null,
        name: '',
        displayName: '',
        type: null,
        color: null,
        size: null,
        price: null,
        imageURL: null,
        inventoriesCount: 0
      }

      // check available sizes by color
      let { colorSizeDictionary } = this.localBundleItems[bundleIndex]

      let availableSizesByColor = colorSizeDictionary.filter(
        colorSize => colorSize.color === variantColor
      )

      let { sizesToDisplay } = this.localBundleItems[bundleIndex]

      if (sizesToDisplay.length) {
        for (let index = 0; index < sizesToDisplay.length; index++) {
          let foundSize = availableSizesByColor.find(
            availableSize =>
              availableSize.size === sizesToDisplay[index].size &&
              availableSize.type ===
                this.localBundleItems[bundleIndex].selectedType
          )

          if (foundSize) {
            this.localBundleItems[bundleIndex].sizesToDisplay[
              index
            ].disabled = false
          } else {
            this.localBundleItems[bundleIndex].sizesToDisplay[
              index
            ].disabled = true
          }
        }
      } else {
        this.setSelectedVariant(bundleIndex)
        this.updateBundlePrice()
      }
    },
    setVariantSize(variantSize) {
      let { itemIndex } = variantSize
      variantSize = variantSize.label
      let bundleIndex = this.localBundleItems.findIndex(
        bundle => bundle.itemIndex === itemIndex
      )

      this.localBundleItems[bundleIndex].selectedSize = variantSize
      this.setSelectedVariant(bundleIndex)
      this.updateBundlePrice()
    },
    setSelectedVariant(bundleIndex) {
      let foundVariant = []
      // all options are available (types - colors - sizes)
      if (
        this.localBundleItems[bundleIndex].typesToDisplay.length &&
        this.localBundleItems[bundleIndex].colorsToDisplay.length &&
        this.localBundleItems[bundleIndex].sizesToDisplay.length
      ) {
        this.localBundleItems[bundleIndex].productVariants.map(variant => {
          if (
            variant.spec.type ===
              this.localBundleItems[bundleIndex].selectedType &&
            variant.spec.color ===
              this.localBundleItems[bundleIndex].selectedColor &&
            variant.spec.size ===
              this.localBundleItems[bundleIndex].selectedSize
          ) {
            foundVariant.push({ ...variant })
          }
        })

        this.localBundleItems[bundleIndex].selectedVariant = {
          id: parseInt(foundVariant[0].id),
          name: foundVariant[0].product_name,
          displayName: foundVariant[0].product_name,
          type: foundVariant[0].spec.type ? foundVariant[0].spec.type : null,
          size: foundVariant[0].spec.size ? foundVariant[0].spec.size : '',
          color: foundVariant[0].spec.color ? foundVariant[0].spec.color : '',
          price: foundVariant[0].price,
          imageURL:
            foundVariant[0].representative_images.length > 0
              ? foundVariant[0].representative_images[0].url
              : null,
          inventoriesCount: foundVariant[0].inventories_count
        }
      } else if (
        this.localBundleItems[bundleIndex].colorsToDisplay.length &&
        this.localBundleItems[bundleIndex].sizesToDisplay.length &&
        !this.localBundleItems[bundleIndex].typesToDisplay.length
      ) {
        // only colors - sizes are available
        this.localBundleItems[bundleIndex].productVariants.map(variant => {
          if (
            variant.spec.color ===
              this.localBundleItems[bundleIndex].selectedColor &&
            variant.spec.size ===
              this.localBundleItems[bundleIndex].selectedSize
          ) {
            foundVariant.push({ ...variant })
          }
        })

        this.localBundleItems[bundleIndex].selectedVariant = {
          id: parseInt(foundVariant[0].id),
          name: foundVariant[0].product_name,
          displayName: foundVariant[0].product_name,
          type: foundVariant[0].spec.type ? foundVariant[0].spec.type : null,
          size: foundVariant[0].spec.size ? foundVariant[0].spec.size : '',
          color: foundVariant[0].spec.color ? foundVariant[0].spec.color : '',
          price: foundVariant[0].price,
          imageURL:
            foundVariant[0].representative_images.length > 0
              ? foundVariant[0].representative_images[0].url
              : null,
          inventoriesCount: foundVariant[0].inventories_count
        }
      } else if (
        !this.localBundleItems[bundleIndex].colorsToDisplay.length &&
        this.localBundleItems[bundleIndex].sizesToDisplay.length &&
        this.localBundleItems[bundleIndex].typesToDisplay.length
      ) {
        // only types - sizes are available

        this.localBundleItems[bundleIndex].productVariants.map(variant => {
          if (
            variant.spec.type ===
              this.localBundleItems[bundleIndex].selectedType &&
            variant.spec.size ===
              this.localBundleItems[bundleIndex].selectedSize
          ) {
            foundVariant.push({ ...variant })
          }
        })

        this.localBundleItems[bundleIndex].selectedVariant = {
          id: parseInt(foundVariant[0].id),
          name: foundVariant[0].product_name,
          displayName: foundVariant[0].product_name,
          type: foundVariant[0].spec.type ? foundVariant[0].spec.type : null,
          size: foundVariant[0].spec.size ? foundVariant[0].spec.size : '',
          color: foundVariant[0].spec.color ? foundVariant[0].spec.color : '',
          price: foundVariant[0].price,
          imageURL:
            foundVariant[0].representative_images.length > 0
              ? foundVariant[0].representative_images[0].url
              : null,
          inventoriesCount: foundVariant[0].inventories_count
        }
      } else if (
        this.localBundleItems[bundleIndex].colorsToDisplay.length &&
        !this.localBundleItems[bundleIndex].typesToDisplay.length &&
        !this.localBundleItems[bundleIndex].sizesToDisplay.length
      ) {
        // only colors are available
        this.localBundleItems[bundleIndex].productVariants.map(variant => {
          if (
            variant.spec.color ===
            this.localBundleItems[bundleIndex].selectedColor
          ) {
            foundVariant.push({ ...variant })
          }
        })

        this.localBundleItems[bundleIndex].selectedVariant = {
          id: parseInt(foundVariant[0].id),
          name: foundVariant[0].product_name,
          displayName: foundVariant[0].product_name,
          type: foundVariant[0].spec.type ? foundVariant[0].spec.type : null,
          size: foundVariant[0].spec.size ? foundVariant[0].spec.size : '',
          color: foundVariant[0].spec.color ? foundVariant[0].spec.color : '',
          price: foundVariant[0].price,
          imageURL:
            foundVariant[0].representative_images.length > 0
              ? foundVariant[0].representative_images[0].url
              : null,
          inventoriesCount: foundVariant[0].inventories_count
        }
      } else if (
        !this.localBundleItems[bundleIndex].colorsToDisplay.length &&
        !this.localBundleItems[bundleIndex].typesToDisplay.length &&
        this.localBundleItems[bundleIndex].sizesToDisplay.length
      ) {
        // only sizes are available
        this.localBundleItems[bundleIndex].productVariants.map(variant => {
          if (
            variant.spec.size ===
            this.localBundleItems[bundleIndex].selectedSize
          ) {
            foundVariant.push({ ...variant })
          }
        })

        this.localBundleItems[bundleIndex].selectedVariant = {
          id: parseInt(foundVariant[0].id),
          name: foundVariant[0].product_name,
          displayName: foundVariant[0].product_name,
          type: foundVariant[0].spec.type ? foundVariant[0].spec.type : null,
          size: foundVariant[0].spec.size ? foundVariant[0].spec.size : '',
          color: foundVariant[0].spec.color ? foundVariant[0].spec.color : '',
          price: foundVariant[0].price,
          imageURL:
            foundVariant[0].representative_images.length > 0
              ? foundVariant[0].representative_images[0].url
              : null,
          inventoriesCount: foundVariant[0].inventories_count
        }
      } else if (
        !this.localBundleItems[bundleIndex].colorsToDisplay.length &&
        this.localBundleItems[bundleIndex].typesToDisplay.length &&
        !this.localBundleItems[bundleIndex].sizesToDisplay.length
      ) {
        // only types are available
        this.localBundleItems[bundleIndex].productVariants.map(variant => {
          if (
            variant.spec.type ===
            this.localBundleItems[bundleIndex].selectedType
          ) {
            foundVariant.push({ ...variant })
          }
        })

        this.localBundleItems[bundleIndex].selectedVariant = {
          id: parseInt(foundVariant[0].id),
          name: foundVariant[0].product_name,
          displayName: foundVariant[0].product_name,
          type: foundVariant[0].spec.type ? foundVariant[0].spec.type : null,
          size: foundVariant[0].spec.size ? foundVariant[0].spec.size : '',
          color: foundVariant[0].spec.color ? foundVariant[0].spec.color : '',
          price: foundVariant[0].price,
          imageURL:
            foundVariant[0].representative_images.length > 0
              ? foundVariant[0].representative_images[0].url
              : null,
          inventoriesCount: foundVariant[0].inventories_count
        }
      }
    },
    inventoryDescription() {
      // check through all selected variants the lowest in stock to display
      let inventory_values = this.localBundleItems.map(bundleItem => {
        return bundleItem.selectedVariant.inventoriesCount
      })

      let minInStock = Math.min(...inventory_values)
      this.lowestOnInvetory = minInStock
      return `${minInStock} in stock`
    },
    updateBundlePrice() {
      let bundlePrice = 0
      this.localBundleItems.forEach(bundleItem => {
        let price =
          parseFloat(bundleItem.selectedVariant.price) *
          parseInt(bundleItem.bundleQty)

        bundlePrice += price
      })
      this.retailPrice = this.formatCurrency(
        Number.isNaN(bundlePrice) === true ? 0 : bundlePrice
      )
    },
    addToShoppingBag() {
      let errors = []
      this.localBundleItems.forEach(bundleItem => {
        if (bundleItem.selectedVariant.price === null) {
          errors.push(
            `Can't add product ${bundleItem.productName} without price.`
          )
        }

        if (
          bundleItem.bundleQty > bundleItem.selectedVariant.inventoriesCount
        ) {
          errors.push(
            `Can't add product ${bundleItem.productName}, max quantity reached for this item`
          )
        }
      })

      if (errors.length) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: errors
        })
        return
      }

      this.handleBundleSelection()
    },
    handleBundleSelection() {
      const newBundle = {
        bundle_attributes: this.bundleDetails
          ? this.bundleDetails.attributes
          : null,
        type: 'bundle',
        bundle_id: this.id,
        quantity: 1,
        items: this.localBundleItems.map(bundleItem => {
          return (
            bundleItem && {
              ...bundleItem.selectedVariant,
              quantity: bundleItem.bundleQty
            }
          )
        })
      }

      this.$store.dispatch('order/addBundleItemToShoppingBag', newBundle)
    },
    getTypeOptions(variantTypes, bundleId, itemIndex) {
      let options = []
      for (let index = 0; index < variantTypes.length; index++) {
        const variantType = variantTypes[index]
        options.push({
          code: parseInt(variantType.id),
          label: variantType.type,
          bundleId,
          itemIndex
        })
      }

      return options.sort()
    },
    getSizeOptions(variantSizes, bundleId, itemIndex) {
      let options = []
      for (let index = 0; index < variantSizes.length; index++) {
        const variantSize = variantSizes[index]
        if (!variantSize.disabled) {
          options.push({
            code: parseInt(variantSize.id),
            label: variantSize.size,
            disabled: variantSize.disabled,
            bundleId,
            itemIndex
          })
        }
      }

      return options.sort()
    },
    isSelectable(value) {
      if (!value.disabled) {
        return true
      }
      return false
    }
  },

  watch: {
    bundleItems() {
      this.localBundleItems = [...this.bundleItems]
      this.updateBundlePrice()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.product-details {
  text-align: left;
  margin: 1.5rem 0;

  h2 {
    padding-bottom: 0.25rem;
    font-size: 2rem;
    font-weight: 600;
    color: $main-6;
    line-height: 44px;
  }

  p {
    font-weight: normal;
  }
}

.bundle-detail-wrapper {
  margin: 1rem 0;

  h2 {
    text-align: left;
  }

  h4 {
    text-align: left;
    font-size: 1.1em;
    margin: 1em 0;
  }
}

.product-name {
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  margin: 1rem 0;
}

.product-price-stock {
  text-align: left;
  margin: 0.5rem 0;
  font-size: 16px;
  font-weight: normal;
}

.gallery-container {
  margin: 3.25rem auto;

  .button-gemnote--small {
    width: 11.125rem;
  }
}

.gallery-description {
  margin: 1.25rem 0rem;
  text-align: left;
  font-size: 0.875rem;
}

.bundle-gallery {
  display: flex;
  flex-wrap: wrap;
  grid-column-gap: 1.75rem;
  margin-bottom: 0rem;

  .bundle-holder {
    margin-bottom: 1.75rem;
  }
}

.bundle-gallery > * {
  flex: 0 1 17rem;
}

.portrait {
  height: 290px;
  border: 1px solid $gray-variant-2;
  margin: 0 auto;

  img {
    padding: 2.5rem;
    width: 100%;
    height: 100%;
    max-width: 240px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }
}

.portrait-info {
  bottom: 0;
  padding: 0rem 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    height: 2rem;
    font-size: 0.875rem;
    text-align: center;
    margin: 0.75rem 0px 1.75rem 0;
    font-weight: normal;
    color: $main-6;
  }

  .quantity {
    margin-bottom: 1.5rem;
    text-align: left;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    font-family: $inter;
    width: 40%;

    .multiply {
      margin-left: 7px;
    }

    .count {
      margin-left: auto;
    }
  }

  .type-header {
    margin: 0.5rem 0rem;
    padding: 0 1rem;
    text-align: left;
  }
}

.variant-details {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 1.5rem;

  &.color {
    align-items: center;
  }

  .gift-select {
    width: 100%;
  }

  p {
    width: 30%;
    margin: 0;
    height: auto;
    font-size: 0.875rem;
    margin-bottom: 0.75rem;
    text-align: left;
    font-family: $inter;

    span {
      font-family: $inter;
      font-weight: bold;
      font-weight: 600;
    }
  }
}

.variant-type {
  // list-style: none;
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: end;

  // li:first-child {
  //   margin-left: 0;
  // }

  // li {
  //   cursor: pointer;
  //   margin: 0.5rem 0.5rem 0.5rem 0rem;
  //   font-size: 16px;
  //   line-height: 20px;
  //   padding: 0.3rem 0.3rem;
  //   border-radius: 0px;
  //   background-color: transparent;
  // }

  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 1.5rem;
  gap: 1rem;

  div {
    flex: 1;
  }
}

.selected-type {
  border: 0;
  border-bottom: 1px solid #25282a;
  color: $onyx;
  font-weight: 700;
}

.variant-colors {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;

  .outside-box {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid transparent;
    box-sizing: content-box;
    box-shadow: 0 0 2px grey !important;
  }

  .outside-box.active {
    border: 1px solid #000;
  }

  .color-box {
    color: $tab-ative;
    font-size: 0.875rem;
    cursor: pointer;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.disabled-color {
  pointer-events: none;
  opacity: 0.2;
}

.disabled-size {
  pointer-events: none;
  opacity: 0.2;
}

.variant-sizes {
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 1.5rem;
  gap: 1rem;

  div {
    flex: 1;
  }

  // li {
  //   cursor: pointer;
  //   margin: 0.5rem 0.5rem 0.5rem 0rem;
  //   font-size: 16px;
  //   line-height: 20px;
  //   padding: 0.3rem 0.3rem;
  //   border-radius: 0;
  //   background-color: transparent;
  // }
}

.selected-size {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #25282a;
  color: $onyx;
  font-weight: 700;
}

.bundle-items-list {
  padding-bottom: 1.5rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
